/* candy-product-inside.js — the What's Inside band.
   Split out of the one candy-product.js IIFE (2026-09). */
(function(){
  if(!window.CandyPrd) return;
  /* The [data-inside-zoom] handler is delegated on document from
     candy-product-core.js, so it survives a theme-editor re-render of this
     section (which does NOT re-run the Product section's script) and works
     even when the Product section has been deleted. Nothing to bind here;
     touching the root is enough to prove the core reached this band. */
  window.CandyPrd.ready('.custom-prd7k9[data-prd-part="inside"]', function(root){
    root.setAttribute('data-inside-ready', '');
  });
})();
